
import { createApp } from "vue";
import { createStore } from "vuex";
import setting from "./setting";

const app = createApp({});

app.use(createStore);

const store = new createStore({
  modules: {
    setting
  },
  strict: true
})

export default store;